(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["es6Module"] = factory();
	else
		root["es6Module"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist-module/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(7)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1),
  /* template */
  __webpack_require__(6),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'data-table',
    props: {
        data: Array,
        columnsToDisplay: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        columnsToNotDisplay: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        columnsToSort: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        columnsToNotSort: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        aggregateColumns: {
            type: Boolean,
            default: false
        },
        displayNames: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        filterKey: {
            type: String,
            default: ""
        },
        childHideable: {
            type: Boolean,
            default: false
        },
        childInitHide: {
            type: Boolean,
            default: false
        },
        childTransitionClass: {
            type: String,
            default: ""
        },
        itemsPerPage: {
            type: Number,
            default: -1
        }
    },
    data: function data() {
        var sortOrders = {};
        this.getColumns(this.columnsToDisplay, this.data, this.columnsToNotDisplay).forEach(function (key) {
            return sortOrders[key] = 1;
        });

        var childShow = [];
        if (this.childInitHide) {
            this.data.forEach(function (entry) {
                return childShow.push(false);
            });
        } else {
            this.data.forEach(function (entry) {
                return childShow.push(true);
            });
        }

        return {
            sortKey: '',
            sortOrders: sortOrders,
            childShow: childShow,
            currentPage: 1
        };
    },

    computed: {
        filteredData: function filteredData() {
            var sortKey = this.sortKey;
            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var order = this.sortOrders[sortKey] || 1;
            var data = this.data;
            if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                    });
                });
            }
            if (sortKey) {
                data = data.slice().sort(function (a, b) {
                    a = a[sortKey];
                    b = b[sortKey];
                    return (a === b ? 0 : a > b ? 1 : -1) * order;
                });
            }

            return data;
        },
        columns: function columns() {
            return this.getColumns(this.columnsToDisplay, this.data, this.columnsToNotDisplay);
        },
        totalPages: function totalPages() {
            if (this.itemsPerPage != -1) {
                return Math.ceil(this.filteredData.length / this.itemsPerPage);
            } else {
                return 1;
            }
        },
        paginatedData: function paginatedData() {
            if (this.itemsPerPage != -1 && this.filteredData.length > this.itemsPerPage) {
                var index = this.currentPage * this.itemsPerPage - this.itemsPerPage;
                return this.filteredData.slice(index, index + this.itemsPerPage);
            } else {
                return this.filteredData;
            }
        }
    },
    filters: {
        getDisplayName: function getDisplayName(column, displayNames) {
            if (column in displayNames) {
                return displayNames[column];
            } else {
                return column.charAt(0).toUpperCase() + column.slice(1);
            }
        }
    },
    methods: {
        sortBy: function sortBy(key) {
            var _this = this;

            if (this.colSortable(key)) {
                if (this.childHideable) {
                    this.childShow = this.childShow.map(function (entry) {
                        return !_this.childInitHide;
                    });
                }
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
            }
        },
        getColumns: function getColumns(columns, data, columnsToRemove) {
            if (columns.length === 0) {
                var foundColumns = void 0;
                if (this.aggregateColumns) {
                    var allColumns = [];
                    data.forEach(function (entry) {
                        return allColumns = allColumns.concat(Object.keys(entry));
                    });
                    foundColumns = allColumns.filter(function (item, pos) {
                        return allColumns.indexOf(item) == pos;
                    });
                } else {
                    foundColumns = Object.keys(data[0]);
                }

                if (columnsToRemove.length > 0) {
                    columnsToRemove.forEach(function (col) {
                        var index = foundColumns.indexOf(col);
                        if (index > -1) {
                            foundColumns.splice(index, 1);
                        }
                    });
                }

                return foundColumns;
            } else {
                return columns;
            }
        },
        toggleChild: function toggleChild(index) {
            if (this.childHideable) {
                this.childShow[index] = !this.childShow[index];
                this.childShow.splice(index, 1, this.childShow[index]);
            }
        },
        colSortable: function colSortable(column) {
            if (this.columnsToNotSort.length > 0) {
                return this.columnsToNotSort.indexOf(column) == -1;
            } else if (this.columnsToSort.length > 0) {
                return this.columnsToSort.indexOf(column) != -1;
            } else {
                return true;
            }
        },
        nextPage: function nextPage() {
            if (this.currentPage != this.totalPages) {
                this.currentPage++;
            }
        },
        previousPage: function previousPage() {
            if (this.currentPage != 1) {
                this.currentPage--;
            }
        }
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataTable = undefined;

var _vDataTable = __webpack_require__(0);

var _vDataTable2 = _interopRequireDefault(_vDataTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataTable = {
    install: function install(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        Vue.component('data-table', _vDataTable2.default);
    }
};

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(DataTable);
}

window.DataTable = DataTable;

exports.DataTable = DataTable;
exports.default = DataTable;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.paginatedData.length == 0) ? _c('table', [_c('caption', [_vm._t("caption", [_vm._v(" ")])], 2), _vm._v(" "), _c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', [_vm._v("\n            " + _vm._s(_vm._f("getDisplayName")(key, _vm.displayNames)) + "\n\n        ")])
  }))]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.columns.length
    }
  }, [_vm._t("nodata")], 2)])])]) : (_vm.$scopedSlots.child) ? _c('table', [_c('caption', [_vm._t("caption", [_vm._v(" ")])], 2), _vm._v(" "), _c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("getDisplayName")(key, _vm.displayNames)) + "\n      "), (_vm.colSortable(key)) ? _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
    }) : _vm._e()])
  }))]), _vm._v(" "), _vm._l((_vm.paginatedData), function(entry, index) {
    return _c('tbody', {
      on: {
        "dblclick": function($event) {
          _vm.toggleChild(index)
        }
      }
    }, [_c('tr', _vm._l((_vm.columns), function(key) {
      return _c('td', [_vm._t(key, [_vm._v("\n                " + _vm._s(entry[key]) + "\n            ")], {
        entry: entry
      })], 2)
    })), _vm._v(" "), _c('transition', {
      attrs: {
        "name": _vm.childTransitionClass
      }
    }, [(_vm.$scopedSlots.child && _vm.childShow[index]) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.columns.length
      }
    }, [_vm._t("child", null, {
      entry: entry
    })], 2)]) : _vm._e()])], 1)
  }), _vm._v(" "), (_vm.itemsPerPage != -1 && this.filteredData.length > this.itemsPerPage) ? _c('tfoot', [_vm._v("\n        " + _vm._s(_vm.currentPage * _vm.itemsPerPage - _vm.itemsPerPage + 1) + " - " + _vm._s(Math.min(_vm.currentPage * _vm.itemsPerPage, _vm.filteredData.length)) + " of " + _vm._s(_vm.filteredData.length) + "\n        "), _c('span', {
    staticClass: "previousPage",
    on: {
      "click": _vm.previousPage
    }
  }), _vm._v("  \n        "), _c('span', {
    staticClass: "nextPage",
    on: {
      "click": _vm.nextPage
    }
  })]) : _vm._e()], 2) : _c('table', [_c('caption', [_vm._t("caption", [_vm._v(" ")])], 2), _vm._v(" "), _c('thead', [_c('tr', _vm._l((_vm.columns), function(key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("getDisplayName")(key, _vm.displayNames)) + "\n      "), (_vm.colSortable(key)) ? _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
    }) : _vm._e()])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedData), function(entry, index) {
    return _c('tr', _vm._l((_vm.columns), function(key) {
      return _c('td', [_vm._t(key, [_vm._v("\n                " + _vm._s(entry[key]) + "\n            ")], {
        entry: entry
      })], 2)
    }))
  })), _vm._v(" "), (_vm.itemsPerPage != -1 && this.filteredData.length > this.itemsPerPage) ? _c('tfoot', [_vm._v("\n        " + _vm._s(_vm.currentPage * _vm.itemsPerPage - _vm.itemsPerPage + 1) + " - " + _vm._s(Math.min(_vm.currentPage * _vm.itemsPerPage, _vm.filteredData.length)) + " of " + _vm._s(_vm.filteredData.length) + "\n        "), _c('span', {
    staticClass: "previousPage",
    on: {
      "click": _vm.previousPage
    }
  }), _vm._v("  \n        "), _c('span', {
    staticClass: "nextPage",
    on: {
      "click": _vm.nextPage
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("17ab9244", content, true);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(9)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// main.js